//THIS FILE IS GENERATED BY generate_press_data.py - DO NOT EDIT

const pressData = [
  {
    country: 'Middle East',
    author: 'Textile Today ',
    url: 'https://www.textiletoday.com.bd/italian-fashion-retailer-italist-partners-miracle-project/',
    dateString: 'August 2019',
    articleTitle: 'Italian fashion retailer italist partners with The Miracle Project'
  },
  {
    country: 'USA',
    author: 'Dellahs',
    url: 'https://www.dellahs.com/11-best-luxury-websites-to-shop/',
    dateString: 'July 2019',
    articleTitle: '11 Best Luxury Website To Shop'
  },
  {
    country: 'USA',
    author: 'Glossy',
    url:
      'https://www.glossy.co/fashion/how-shopstyle-looks-to-gain-customer-loyalty-with-personalization-and-cash-back-rewards',
    dateString: 'June 2019',
    articleTitle: 'ShopStyle looks to gain customer loyalty with personalization and cash-back rewards'
  },
  {
    country: 'USA',
    author: 'Medium',
    url: 'https://medium.com/markupgrade/names-with-stories-the-story-behind-italist-com-87e8feccc1bc',
    dateString: 'May 2019',
    articleTitle: 'Names with stories: The story behind Italist.com'
  },
  {
    country: 'Middle East',
    author: 'Entrepreneur',
    url: 'https://www.entrepreneur.com/article/332943',
    dateString: 'April 2019',
    articleTitle: 'Creating Content That Resonates With Your Audience'
  },
  {
    country: 'Middle East',
    author: 'alroeya.com',
    url:
      'https://www.alroeya.com/article/2045204/%D8%A7%D9%82%D8%AA%D8%B5%D8%A7%D8%AF/%D8%A3%D8%B3%D9%88%D8%A7%D9%82/%D8%B3%D9%88%D9%82-%D8%A7%D9%84%D9%85%D9%86%D8%AA%D8%AC%D8%A7%D8%AA-%D8%A7%D9%84%D9%81%D8%A7%D8%AE%D8%B1%D8%A9-%D8%A7%D9%84%D8%A5%D9%84%D9%83%D8%AA%D8%B1%D9%88%D9%86%D9%8A-%D9%81%D9%8A-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D9%86%D8%A7%D9%81%D8%B3-%D9%82%D9%88%D9%8A-%D8%B9%D8%A7%D9%84%D9%85%D9%8A%D8%A7',
    dateString: 'May 2019',
    articleTitle: 'سوق المنتجات الفاخرة الإلكتروني في الإمارات منافس قوي عالمياً'
  },
  {
    country: 'Spain',
    author: 'ABC.es',
    url: 'https://www.abc.es/summum/estilo/moda/abci-donde-compra-lujo-internet-201805091314_noticia.html',
    dateString: 'May 2018',
    articleTitle: '¿Dónde se compra el lujo en Internet?'
  },
  {
    country: 'Middle East',
    author: 'khaleejtimes.com',
    url: 'https://www.khaleejtimes.com/online-retail-demand-will-continue-to-grow-experts',
    dateString: 'April 2018',
    articleTitle: 'Online retail demand will continue to grow: Experts'
  },
  {
    country: 'Russia',
    author: 'SNCMedia',
    url: 'http://www.sncmedia.ru/fashion/zhestkiy-lyuks-kak-odevatsya-v-veshchi-izvestnykh-brendov-i-ne-razoritsya/',
    dateString: 'February 2018',
    articleTitle: 'Жесткий люкс: как одеваться в вещи известных брендов и не разориться'
  },
  {
    country: 'Italy',
    author: 'Agenziacomunica.net',
    url:
      'http://www.agenziacomunica.net/2018/01/06/sport-fashion-e-tech-premiate-le-eccellenze-italiane-negli-stati-uniti/',
    dateString: 'January 2018',
    articleTitle: 'SPORT, FASHION E TECH: PREMIATE LE ECCELLENZE ITALIANE NEGLI STATI UNITI'
  },
  {
    country: 'Spain',
    author: 'Emprendedores.es',
    url: 'http://www.emprendedores.es/ideas-de-negocio/ideas-extranjeras-negocios-para-importar-ya',
    dateString: 'September 2017',
    articleTitle: '17 ideas extranjeras para importar ya'
  },
  {
    country: 'South Africa',
    author: 'Glamour',
    url: 'http://glamour.co.za/2017/03/glamour-guides-15-03-17/',
    dateString: 'March 2017',
    articleTitle: 'GLAMOUR Guides: 15.03.17'
  },
  {
    country: 'South Africa',
    author: 'bizcommunity.com',
    url: 'http://www.bizcommunity.com/Article/196/394/159284.html',
    dateString: 'March 2017',
    articleTitle: 'Luxury online shopping platform Italist launches in SA'
  },
  {
    country: 'South Africa',
    author: 'Fastmoving',
    url:
      'http://www.fastmoving.co.za/news/retailer-news-16/bricks-and-mortar-retailers-with-no-omnichannel-strategy-face-closure-9864',
    dateString: 'March 2017',
    articleTitle: '‘Bricks and Mortar’ retailers with no omnichannel strategy face closure'
  },
  {
    country: 'USA',
    author: 'Wefunder',
    url: 'https://wefunder.com/italist',
    dateString: 'Dec 2016',
    articleTitle: 'ITALIST The first online marketplace for Italian fashion'
  },
  {
    country: 'USA',
    author: 'G-Startup Worldwide',
    url: 'http://g-startup.com/g-startup-worldwide-global-finals/',
    dateString: 'September 2016',
    articleTitle: 'Top 15 Startups Revealed for G-Startup Worldwide Silicon Valley of Global Finals 2016'
  },
  {
    country: 'Singapore',
    author: 'Singapore Tatler',
    url: 'https://sg.asiatatler.com/style/up-close-with-raffaele-giovine-italist-s-co-founder-and-chairman',
    dateString: 'June 2016',
    articleTitle: '5 Minutes With... Raffaele Giovine, Italist’s Co-founder and Chairman'
  },
  {
    country: 'USA',
    author: 'Racked',
    url: 'http://www.racked.com/2016/5/3/11503316/italist-italian-boutiques-online-discount',
    dateString: 'May 2016',
    articleTitle: 'The Site That Brings Italian Boutiques Right to Your Computer'
  },
  {
    country: 'Italy',
    author: 'StartUpItalia',
    url: 'https://startupitalia.eu/55560-20160506-italist-abba-giovine-500-startup',
    dateString: 'May 2016',
    articleTitle: 'Due italiani creano negli Usa un ecommerce delle nostre migliori boutique (incubati da 500 Startup)'
  },
  {
    country: 'Korea',
    author: 'koreaherald.com',
    url: 'http://www.koreaherald.com/view.php?ud=20150521000713',
    dateString: 'May 2015',
    articleTitle: 'Foreign start-ups edge in on Korean tech turf'
  },
  {
    country: 'Portugal',
    author: 'Fashion Up',
    url: 'http://www.fashionup.pt/italia-entre-cliques/',
    dateString: 'May 2015',
    articleTitle: 'ITÁLIA ENTRE CLIQUES'
  },
  {
    country: 'USA',
    author: 'Silicon Valley Business Journal',
    url:
      'http://www.bizjournals.com/sanjose/blog/techflash/2015/02/5-faves-and-4-things-to-know-from-500-startups.html?page=3',
    dateString: 'February 2015',
    articleTitle: '5 faves and 4 things to know from 500 Startups Demo Day'
  },
  {
    country: 'USA',
    author: 'Mattermark',
    url: 'https://mattermark.com/500-startups-batch-11-demo-day-sorted-by-the-growth-score/',
    dateString: 'February 2015',
    articleTitle: '500 Startups Batch 11 Demo Day – Sorted By The Growth Score'
  },
  {
    country: 'USA',
    author: 'Techcrunch',
    url:
      'https://techcrunch.com/2015/01/13/500-startups-backed-italist-is-like-shopping-the-streets-of-italy-but-online/',
    dateString: 'January 2015',
    articleTitle: '500 Startups-Backed Italist Is Like Shopping The Streets Of Italy, But Online'
  },
  {
    country: 'USA',
    author: '500.co',
    url: 'https://500.co/500-startups-announces-batch-11-in-mountain-view/',
    dateString: 'November 2014',
    articleTitle: '500 Startups Announces Batch 11 in Mountain View'
  },
  {
    country: 'Italy',
    author: 'Elle',
    url: 'https://www.elle.com/it/shopping/news/a1037450/italist-shop-on-line-marketplace-italiano-shopping-1/',
    dateString: 'May 2014',
    articleTitle:
      'Italist - shop on line & più grande marketplace italiano - vince il premio U-Start come migliore startup d’Europa'
  }
];

export default pressData;
